(function() {
  // Every user-visible string this file writes comes from window.SaifI18n.maqamlib, which the
  // saif-i18n bridge fills from the same saif.maqamlib.* keys the section's Liquid renders — so
  // a string is never translated twice and never drifts between the two. The English literal
  // stays as the fallback so this file still works with no bridge on the page.
  function mqt(key, fallback, vars) {
    // Read on every call, never cached at parse time: this file must not depend on the bridge
    // <script> having already run, which is an ordering assumption nothing here guarantees.
    var mq = (window.SaifI18n && window.SaifI18n.maqamlib) || {};
    var s = mq[key] || fallback;
    if (vars) for (var k in vars) s = s.split('{' + k + '}').join(vars[k]);
    return s;
  }
  var library = document.getElementById('SaifMaqamLibrary');
  if (!library) return;
  var currentAudio = null;
  var currentBtn = null;

  /**
   * First Maqam-478 manifest clip per maqam handle — used as the fallback
   * audio source for inline card players whose audio_url setting is blank.
   * The manifest is an inline JSON island, so this parse is synchronous.
   */
  var firstManifestClip = {};
  try {
    var manifestNode = document.getElementById('SaifMaqam478Manifest');
    if (manifestNode && manifestNode.textContent.trim()) {
      (JSON.parse(manifestNode.textContent).items || []).forEach(function (item) {
        var key = (item.maqam || '').toLowerCase();
        if (!firstManifestClip[key]) firstManifestClip[key] = item;
      });
    }
  } catch (err) {
    console.warn('[saif-maqam-library] could not parse manifest for card players:', err && err.message);
  }

  /** Pause the inline card player (if any) and clear its playing state. */
  function pauseCardAudio() {
    if (currentAudio) { try { currentAudio.pause(); } catch (e) {} }
    if (currentBtn) {
      var playerEl = currentBtn.closest('.saif-maqam-card__player');
      if (playerEl) playerEl.classList.remove('saif-maqam-card__player--playing');
    }
  }

  library.querySelectorAll('.saif-maqam-card__player').forEach(function(player) {
    var url = player.getAttribute('data-audio-url');
    if (!url) {
      // No admin-set sample — fall back to the maqam's first manifest clip
      // so every card has a working inline player.
      var cardForPlayer = player.closest('.saif-maqam-card');
      var cardHandle = cardForPlayer ? (cardForPlayer.getAttribute('data-maqam-handle') || '').toLowerCase() : '';
      var fallbackClip = firstManifestClip[cardHandle];
      if (fallbackClip && fallbackClip.url) {
        url = fallbackClip.url;
        player.setAttribute('data-audio-url', url);
      }
    }
    if (!url) { player.hidden = true; return; }
    var audio = new Audio(url);
    // Duration only — full audio streams in once the user actually plays.
    audio.preload = 'metadata';
    var btn = player.querySelector('.saif-maqam-card__play-btn');
    var fill = player.querySelector('.saif-maqam-card__progress-fill');
    var speeds = player.querySelectorAll('.saif-maqam-card__speed');

    audio.addEventListener('timeupdate', function() {
      if (audio.duration) fill.style.width = (audio.currentTime / audio.duration * 100) + '%';
    });
    audio.addEventListener('ended', function() {
      player.classList.remove('saif-maqam-card__player--playing');
    });

    btn.addEventListener('click', function() {
      if (currentAudio && currentAudio !== audio) {
        currentAudio.pause(); currentAudio.currentTime = 0;
        if (currentBtn) currentBtn.closest('.saif-maqam-card__player').classList.remove('saif-maqam-card__player--playing');
      }
      if (audio.paused) {
        if (window.SaifTrack) {
          var card = player.closest('.saif-maqam-card');
          var nameEl = card && card.querySelector('.saif-maqam-card__name');
          window.SaifTrack('maqam_clip_played', {
            clip_name: nameEl ? nameEl.textContent.trim() : null,
            clip_url: url
          });
        }
        audio.play();
        player.classList.add('saif-maqam-card__player--playing');
        currentAudio = audio; currentBtn = btn;
      } else {
        audio.pause();
        player.classList.remove('saif-maqam-card__player--playing');
      }
    });

    speeds.forEach(function(s) {
      s.addEventListener('click', function() {
        audio.playbackRate = parseFloat(s.getAttribute('data-speed'));
        speeds.forEach(function(x) { x.classList.remove('saif-maqam-card__speed--active'); });
        s.classList.add('saif-maqam-card__speed--active');
      });
    });
  });

  /* =========================================================
     RECITATION EXAMPLES MODAL
     - Curated admin examples (rich context: reciter / surah / notes)
     - Maqam-478 dataset library (loaded async from manifest)
     ========================================================= */
  var dataEl = document.getElementById('SaifMaqamExamplesData');
  var modal = document.getElementById('SaifMaqamExamplesModal');
  var modalList = document.getElementById('SaifMaqamExamplesList');
  var modalTitle = document.getElementById('SaifMaqamExamplesTitle');
  var modalClose = document.getElementById('SaifMaqamExamplesClose');
  if (dataEl && modal && modalList && modalTitle) {
    var curatedExamples = [];
    try { curatedExamples = (JSON.parse(dataEl.textContent || '{}').examples) || []; }
    catch (err) { curatedExamples = []; }

    var datasetByMaqam = {}; // populated synchronously from the inline data island
    var datasetLoaded = false;
    var modalAudios = [];

    function escapeHtml(s) {
      return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
        return { '&':'&amp;', '<':'&lt;', '>':'&gt;', '"':'&quot;', "'":'&#39;' }[c];
      });
    }

    /**
     * Load the Maqam-478 manifest from the inline <script id="SaifMaqam478Manifest">
     * tag emitted by snippets/maqam-478-manifest.liquid. Synchronous — no fetch.
     * If the snippet doesn't exist (script never run), this is a no-op.
     */
    function loadDataset() {
      if (datasetLoaded) return Promise.resolve();
      try {
        var node = document.getElementById('SaifMaqam478Manifest');
        if (node && node.textContent.trim()) {
          var data = JSON.parse(node.textContent);
          var items = (data && data.items) || [];
          for (var i = 0; i < items.length; i++) {
            var it = items[i];
            var key = (it.maqam || '').toLowerCase();
            if (!datasetByMaqam[key]) datasetByMaqam[key] = [];
            datasetByMaqam[key].push(it);
          }
        }
      } catch (err) {
        console.warn('[saif-maqam-library] could not parse Maqam-478 manifest:', err && err.message);
      }
      datasetLoaded = true;
      return Promise.resolve();
    }

    /**
     * After the manifest loads, bump the count on each maqam button to
     * include dataset items, and reveal buttons that were hidden because
     * they had no curated examples.
     */
    function updateButtonCounts() {
      library.querySelectorAll('[data-open-examples]').forEach(function (btn) {
        var handle = (btn.getAttribute('data-maqam-handle') || '').toLowerCase();
        var curated = parseInt(btn.getAttribute('data-curated-count'), 10) || 0;
        var datasetCount = (datasetByMaqam[handle] || []).length;
        var total = curated + datasetCount;
        if (total === 0) return;

        btn.hidden = false;
        var label = btn.querySelector('.saif-maqam-card__examples-btn-label');
        if (label) {
          label.textContent = total === 1
            ? mqt('view_examples_one', 'View 1 example')
            : mqt('view_examples', 'View {n} examples', { n: total });
        }
      });
    }

    function renderExamples(handle, displayName) {
      modalTitle.textContent = mqt('modal_title', 'Examples of Maqam {maqam}', { maqam: displayName || handle });
      modalAudios.forEach(function (a) { try { a.pause(); } catch (e) {} });
      modalAudios = [];

      var curated = curatedExamples.filter(function (ex) {
        return (ex.maqamHandle || '').toLowerCase() === handle;
      });
      var dataset = datasetByMaqam[handle] || [];

      if (!curated.length && !dataset.length) {
        modalList.innerHTML = '<p class="saif-maqam-examples-modal__empty">' +
          (datasetLoaded
            ? mqt('no_examples', 'No examples for this maqam yet.')
            : mqt('loading_examples', 'Loading examples\u2026')) +
          '</p>';
        return;
      }

      var html = '';

      function renderClipCard(opts) {
        return '<article class="saif-maqam-clip" data-audio-url="' + escapeHtml(opts.url) + '" data-clip-title="' + escapeHtml(opts.title) + '">' +
          '<div class="saif-maqam-clip__main">' +
            '<button type="button" class="saif-maqam-clip__play" aria-label="' + escapeHtml(mqt('play_clip', 'Play {clip}', { clip: opts.title })) + '">' +
              '<svg class="saif-maqam-clip__icon-play" width="16" height="16" viewBox="0 0 24 24" fill="currentColor"><polygon points=\"6 3 20 12 6 21 6 3\"/></svg>' +
              '<svg class="saif-maqam-clip__icon-pause" width="16" height="16" viewBox="0 0 24 24" fill="currentColor" hidden><rect x=\"5\" y=\"3\" width=\"4\" height=\"18\" rx=\"1\"/><rect x=\"15\" y=\"3\" width=\"4\" height=\"18\" rx=\"1\"/></svg>' +
            '</button>' +
            '<div class="saif-maqam-clip__meta">' +
              '<div class="saif-maqam-clip__title">' + escapeHtml(opts.title) + '</div>' +
              (opts.subtitle ? '<div class="saif-maqam-clip__subtitle">' + escapeHtml(opts.subtitle) + '</div>' : '') +
            '</div>' +
            '<div class="saif-maqam-clip__progress"><div class="saif-maqam-clip__progress-fill"></div></div>' +
            '<span class="saif-maqam-clip__time">0:00</span>' +
            '<button type="button" class="saif-maqam-clip__practice" data-practice-url="' + escapeHtml(opts.url) + '" data-practice-title="' + escapeHtml(opts.title) + '" title="' + escapeHtml(mqt('practice_along', 'Practice along with this clip')) + '">' +
              '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d=\"M12 1a3 3 0 0 0-3 3v8a3 3 0 0 0 6 0V4a3 3 0 0 0-3-3z\"/><path d=\"M19 10v2a7 7 0 0 1-14 0v-2\"/><line x1=\"12\" y1=\"19\" x2=\"12\" y2=\"23\"/><line x1=\"8\" y1=\"23\" x2=\"16\" y2=\"23\"/></svg>' +
              '<span>' + escapeHtml(mqt('practice', 'Practice')) + '</span>' +
            '</button>' +
          '</div>' +
          (opts.notes ? '<div class="saif-maqam-clip__notes rte">' + opts.notes + '</div>' : '') +
        '</article>';
      }

      if (curated.length) {
        html += '<section class="saif-maqam-examples-modal__group">';
        html += '<h3 class="saif-maqam-examples-modal__group-title">' + escapeHtml(mqt('curated_examples', 'Curated examples')) + '</h3>';
        html += curated.map(function (ex) {
          if (!ex.audioUrl) return '';
          var title = ex.reciter || 'Reciter';
          var subtitle = '';
          if (ex.surah) subtitle = ex.surah + (ex.ayahRange ? ' (' + ex.ayahRange + ')' : '');
          else if (ex.ayahRange) subtitle = ex.ayahRange;
          return renderClipCard({ url: ex.audioUrl, title: title, subtitle: subtitle, notes: ex.notes });
        }).join('');
        html += '</section>';
      }

      if (dataset.length) {
        html += '<section class="saif-maqam-examples-modal__group">';
        html += '<h3 class="saif-maqam-examples-modal__group-title">' + escapeHtml(mqt('recitation_library', 'Recitation library')) + ' <span>(Maqam-478)</span></h3>';
        html += '<p class="saif-maqam-examples-modal__group-hint">' + escapeHtml(mqt('dataset_hint', 'Tagged audio clips from an academic Quranic recitation dataset (CC-BY). Click the mic on any clip to practice along.')) + '</p>';
        html += dataset.map(function (item, idx) {
          var title = mqt('clip_n', 'Clip {n}', { n: idx + 1 });
          var subtitle = '';
          if (item.filename) {
            subtitle = String(item.filename).replace(/\.[^.]+$/, '').replace(/[_-]/g, ' ');
          }
          return renderClipCard({ url: item.url, title: title, subtitle: subtitle });
        }).join('');
        html += '</section>';
      }

      modalList.innerHTML = html;
      wireClipCards(modalList);
    }

    /**
     * Bind play/pause + scrub + practice handlers to every .saif-maqam-clip
     * card. Each card has its own Audio() - only one can play at a time.
     */
    function wireClipCards(container) {
      modalAudios = [];
      var clipVisibilityObserver = ('IntersectionObserver' in window)
        ? new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
              if (!entry.isIntersecting) return;
              var fn = entry.target._saifEnsureSrc;
              if (fn) fn();
              clipVisibilityObserver.unobserve(entry.target);
            });
          }, { rootMargin: '200px' })
        : null;
      container.querySelectorAll('.saif-maqam-clip').forEach(function (card) {
        var url = card.getAttribute('data-audio-url');
        if (!url) return;
        // src is assigned lazily: with the full 478-clip dataset a modal can
        // hold 70+ cards, and eagerly created players each fetch ~64KB of
        // metadata — a multi-MB stampede on open that queues ahead of the
        // clip the user actually clicks. The IntersectionObserver below
        // assigns src as cards scroll into view (duration still appears
        // before play for everything visible); play() assigns it on demand.
        var audio = new Audio();
        audio.preload = 'metadata';
        var srcSet = false;
        function ensureSrc() {
          if (!srcSet) { srcSet = true; audio.src = url; }
        }
        if (clipVisibilityObserver) {
          card._saifEnsureSrc = ensureSrc;
          clipVisibilityObserver.observe(card);
        } else {
          ensureSrc();
        }
        var iconPlay = card.querySelector('.saif-maqam-clip__icon-play');
        var iconPause = card.querySelector('.saif-maqam-clip__icon-pause');
        var fill = card.querySelector('.saif-maqam-clip__progress-fill');
        var progress = card.querySelector('.saif-maqam-clip__progress');
        var timeEl = card.querySelector('.saif-maqam-clip__time');
        var playBtn = card.querySelector('.saif-maqam-clip__play');
        var practiceBtn = card.querySelector('.saif-maqam-clip__practice');

        function setPlaying(playing) {
          // toggleAttribute, not `.hidden =` — the hidden IDL property doesn't
          // exist on SVG-namespace elements, so assigning it is a silent no-op.
          if (iconPlay) iconPlay.toggleAttribute('hidden', !!playing);
          if (iconPause) iconPause.toggleAttribute('hidden', !playing);
          card.classList.toggle('saif-maqam-clip--playing', !!playing);
        }

        audio.addEventListener('timeupdate', function () {
          if (audio.duration) fill.style.width = (audio.currentTime / audio.duration * 100) + '%';
          if (timeEl) timeEl.textContent = formatClipTime(audio.currentTime) + ' / ' + formatClipTime(audio.duration || 0);
        });
        // preload='metadata' means the duration is known before first play —
        // show it instead of a bare "0:00".
        audio.addEventListener('loadedmetadata', function () {
          if (timeEl && audio.duration) timeEl.textContent = '0:00 / ' + formatClipTime(audio.duration);
        });
        audio.addEventListener('play', function () {
          pauseCardAudio();
          modalAudios.forEach(function (other) {
            if (other !== audio) try { other.pause(); } catch (e) {}
          });
          setPlaying(true);
        });
        audio.addEventListener('pause', function () { setPlaying(false); });
        audio.addEventListener('ended', function () {
          setPlaying(false);
          try { audio.currentTime = 0; } catch (e) {}
        });

        // Track whether the audio has buffered enough to play smoothly. If a
        // user clicks Play before this fires, we show a loading state on the
        // button so the dead-time-while-fetching is visible feedback rather
        // than apparent unresponsiveness.
        var canPlayThrough = false;
        audio.addEventListener('canplay', function () { canPlayThrough = true; card.classList.remove('saif-maqam-clip--loading'); });
        audio.addEventListener('waiting', function () { card.classList.add('saif-maqam-clip--loading'); });
        audio.addEventListener('playing', function () { card.classList.remove('saif-maqam-clip--loading'); });

        playBtn.addEventListener('click', function () {
          if (audio.paused || audio.ended) {
            // Bump preload to 'auto' the first time the user shows intent to
            // play — guarantees the rest of the file loads ASAP without
            // pre-fetching every clip in the modal up front.
            ensureSrc();
            audio.preload = 'auto';
            if (!canPlayThrough && audio.readyState < 3) {
              card.classList.add('saif-maqam-clip--loading');
            }
            audio.play().catch(function (err) {
              card.classList.remove('saif-maqam-clip--loading');
              console.error('[saif-maqam] play failed:', err && err.name, err && err.message);
            });
          } else {
            audio.pause();
          }
        });
        // Pointer-drag scrubbing instead of a bare click handler — click-only
        // seeking gives touch users no way to drag to the phrase they want to
        // re-hear. Pointer capture keeps the drag alive even when the finger
        // wanders off the bar, and touch-action: none stops the page from
        // scroll-stealing the gesture (no CSS file change needed).
        progress.style.touchAction = 'none';
        var scrubbing = false;
        function seekToPointer(e) {
          if (!audio.duration) return;
          var rect = progress.getBoundingClientRect();
          if (!rect.width) return;
          var ratio = Math.max(0, Math.min(1, (e.clientX - rect.left) / rect.width));
          audio.currentTime = ratio * audio.duration;
          // Move the fill immediately so the bar tracks the finger instead of
          // waiting on the next (throttled) timeupdate.
          fill.style.width = (ratio * 100) + '%';
        }
        progress.addEventListener('pointerdown', function (e) {
          if (!audio.duration) return;
          scrubbing = true;
          if (progress.setPointerCapture) {
            try { progress.setPointerCapture(e.pointerId); } catch (err) {}
          }
          seekToPointer(e);
        });
        progress.addEventListener('pointermove', function (e) {
          if (scrubbing) seekToPointer(e);
        });
        function stopScrub() { scrubbing = false; }
        progress.addEventListener('pointerup', stopScrub);
        progress.addEventListener('pointercancel', stopScrub);
        if (practiceBtn) {
          practiceBtn.addEventListener('click', function () {
            try { audio.pause(); } catch (e) {}
            // No more explicit fetch() here — the audio element does its
            // own request when refAudio.src is set inside loadReference,
            // and the duplicate XHR was racing the media-element fetch
            // (browsers don't always dedupe across the two). Letting the
            // <audio> element own the network is faster and simpler.
            openPracticeModal(url, card.getAttribute('data-clip-title') || 'Practice');
          });
        }

        modalAudios.push(audio);
      });
    }

    function formatClipTime(seconds) {
      if (!isFinite(seconds) || seconds < 0) seconds = 0;
      var m = Math.floor(seconds / 60);
      var s = Math.floor(seconds % 60);
      return m + ':' + (s < 10 ? '0' : '') + s;
    }

    /**
     * Lock body scroll while either dialog is open. Native <dialog> doesn't
     * do this, so touch momentum otherwise scrolls the page behind the modal.
     * Safe to call from anywhere — it re-derives state from the DOM.
     *
     * iOS Safari ignores a plain body `overflow: hidden` for touch
     * scrolling, so this uses the position:fixed body-lock pattern: pin
     * the body at the current scroll offset while locked, restore the
     * offset on unlock. State-guarded so stacked opens (practice modal
     * over the examples modal) don't re-capture a bogus scrollY of 0 —
     * the lock is taken once on the first open and released only when
     * both dialogs are closed.
     */
    var scrollLockY = 0;
    var scrollLocked = false;
    function syncScrollLock() {
      var anyOpen = !!(modal.hasAttribute('open') ||
        (practiceModal && practiceModal.hasAttribute('open')));
      if (anyOpen === scrollLocked) return;
      if (anyOpen) {
        scrollLockY = window.scrollY || window.pageYOffset || 0;
        document.body.style.position = 'fixed';
        document.body.style.top = -scrollLockY + 'px';
        document.body.style.left = '0';
        document.body.style.right = '0';
        document.body.style.width = '100%';
        document.body.style.overflow = 'hidden';
        document.documentElement.style.overflow = 'hidden';
        scrollLocked = true;
      } else {
        document.body.style.position = '';
        document.body.style.top = '';
        document.body.style.left = '';
        document.body.style.right = '';
        document.body.style.width = '';
        document.body.style.overflow = '';
        document.documentElement.style.overflow = '';
        scrollLocked = false;
        // Restore the pre-lock offset without tripping any global
        // `scroll-behavior: smooth` into animating the jump.
        var docEl = document.documentElement;
        var prevBehavior = docEl.style.scrollBehavior;
        docEl.style.scrollBehavior = 'auto';
        window.scrollTo(0, scrollLockY);
        docEl.style.scrollBehavior = prevBehavior;
      }
    }

    function openModal(handle, displayName) {
      // Dataset is loaded synchronously from the inline script tag;
      // if it hasn't been called yet, do it now so the library section appears.
      loadDataset();
      // Warm this family's pre-computed pitch file (studio hook) so clicking
      // Practice on any clip in the gallery gets its graph instantly instead
      // of paying the ~380KB fetch at click time.
      if (window.SaifPrefetchPitchFamily) window.SaifPrefetchPitchFamily(handle);
      renderExamples(handle, displayName);
      // Don't let an inline card sample keep playing under the modal clips.
      pauseCardAudio();
      if (typeof modal.showModal === 'function') modal.showModal();
      else modal.setAttribute('open', '');
      syncScrollLock();
    }

    function closeModal() {
      modalAudios.forEach(function (a) { try { a.pause(); } catch (e) {} });
      if (typeof modal.close === 'function') modal.close();
      else modal.removeAttribute('open');
      syncScrollLock();
    }

    /* =========================================================
       PRACTICE MODAL — embeds the practice studio with the
       clicked clip as the reference audio
       ========================================================= */
    var practiceModal = document.getElementById('SaifMaqamPracticeModal');
    var practiceClose = document.getElementById('SaifMaqamPracticeClose');
    var practiceTitle = document.getElementById('SaifMaqamPracticeTitle');
    var practiceStudioEl = document.getElementById('SaifPracticeStudio');

    function openPracticeModal(audioUrl, clipTitle) {
      if (!practiceModal || !practiceStudioEl) return;
      if (window.SaifTrack) window.SaifTrack('maqam_practice_opened', {
        clip_title: clipTitle,
        clip_url: audioUrl
      });
      if (practiceTitle) practiceTitle.textContent = mqt('practice_of', 'Practice — {clip}', { clip: clipTitle });

      // Hand the new reference URL to the practice studio. If its JS instance
      // has already initialized, call loadReference() to swap audio + reset
      // pitch caches; otherwise just set the data-attribute for first init.
      practiceStudioEl.setAttribute('data-reference-url', audioUrl);
      // Stash the clip title on the container so loadReference / history-render
      // can read it without us threading the title through every call site.
      practiceStudioEl.setAttribute('data-reference-title', clipTitle || '');
      var studio = window.SaifPracticeStudio;
      if (studio && typeof studio.loadReference === 'function') {
        studio.loadReference(audioUrl, { clipTitle: clipTitle });
      }

      // Hook up the dedicated clip bar at the top of the modal — wires its
      // play button + progress to the same #SaifPracticeRefAudio element the
      // practice studio uses, so playback state stays in sync everywhere.
      wireClipBar(audioUrl, clipTitle);

      // Pause any modal audio so it doesn't overlap with reference playback
      modalAudios.forEach(function (a) { try { a.pause(); } catch (e) {} });

      if (typeof practiceModal.showModal === 'function') practiceModal.showModal();
      else practiceModal.setAttribute('open', '');
      syncScrollLock();
    }

    /**
     * Set up the practice modal's reference clip bar (title + play button +
     * progress). Driven by #SaifPracticeRefAudio so play/pause from anywhere
     * (Listen button, in-tuner Play button, or this banner) all mirror state.
     * Idempotent — safe to call every time the practice modal opens.
     */
    function wireClipBar(audioUrl, clipTitle) {
      var titleEl = document.getElementById('SaifPracticeClipTitle');
      var playBtn = document.getElementById('SaifPracticeClipPlay');
      var progress = document.getElementById('SaifPracticeClipProgress');
      var fill = document.getElementById('SaifPracticeClipProgressFill');
      var timeEl = document.getElementById('SaifPracticeClipTime');
      var refAudio = document.getElementById('SaifPracticeRefAudio');
      var speedSel = document.getElementById('SaifPracticeClipSpeed');
      var muteBtn = document.getElementById('SaifPracticeClipMute');
      var volSlider = document.getElementById('SaifPracticeClipVolume');
      var optionsBtn = document.getElementById('SaifPracticeClipOptionsBtn');
      var optionsPanel = document.getElementById('SaifPracticeClipOptions');
      if (!playBtn || !refAudio) {
        console.warn('[saif-maqam] clip bar wiring skipped — missing elements');
        return;
      }

      // Options disclosure — collapsed by default. Toggle on click; close
      // when the user clicks anywhere outside the panel + button. Keeps the
      // visible row tight (Title · Progress · Time · Play) without losing
      // any functionality.
      if (optionsBtn && optionsPanel && !optionsBtn._wired) {
        optionsBtn._wired = true;
        var setOptionsOpen = function (open) {
          optionsPanel.hidden = !open;
          optionsBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
          optionsBtn.classList.toggle('saif-maqam-practice-modal__clip-options-btn--active', !!open);
        };
        optionsBtn.addEventListener('click', function (evt) {
          evt.stopPropagation();
          setOptionsOpen(optionsPanel.hidden);
        });
        document.addEventListener('click', function (evt) {
          if (optionsPanel.hidden) return;
          if (optionsPanel.contains(evt.target) || optionsBtn.contains(evt.target)) return;
          setOptionsOpen(false);
        });
        // Re-collapse on Escape for keyboard users
        document.addEventListener('keydown', function (evt) {
          if (evt.key === 'Escape' && !optionsPanel.hidden) {
            setOptionsOpen(false);
            optionsBtn.focus();
          }
        });
      }

      if (titleEl) titleEl.textContent = clipTitle || mqt('reference_clip', 'Reference clip');
      if (fill) fill.style.width = '0%';
      if (timeEl) timeEl.textContent = '0:00 / 0:00';

      // Buffering state shows as a ring-spinner on the play button itself.
      // No more full-screen "Loading clip…" overlay — the practice studio
      // UI stays interactive while the audio buffers; only the play action
      // is gated. Race-safe:
      //   1. If readyState >= 2 (HAVE_CURRENT_DATA), no spinner — clip is
      //      already buffered (e.g. user just listened to it in the inline
      //      example player or the openPracticeModal prefetch warmed cache).
      //   2. Otherwise add the --loading class; remove on loadeddata/canplay
      //      (whichever fires first — Safari sometimes skips canplay) or
      //      error or after a 4s fallback timer.
      // setLoading queries the play button live (by ID) instead of closing
      // over the `playBtn` variable, because we re-clone the button below
      // to wipe stale listeners — closing over the old reference would
      // leave the spinner stuck on a detached node while the visible
      // (cloned) button shows no buffering state.
      // No more "loading" gate on the play button. The audio element is
      // already streaming progressively (preload=metadata in
      // loadReference). Clicking Play works immediately: if the buffer
      // isn't full, the browser fills it during playback. Subjectively
      // far faster than waiting for a full preload before enabling the
      // button — which previously meant 3-10s of dead spinner on
      // multi-MB MP3s. We still log error events so a broken URL or
      // CORS failure surfaces in the console.
      console.log('[saif-maqam] wireClipBar: refAudio readyState at start:', refAudio.readyState);
      if (!refAudio._errorWired) {
        refAudio._errorWired = true;
        refAudio.addEventListener('error', function () {
          console.error('[saif-maqam] refAudio error — code:', refAudio.error && refAudio.error.code,
            'msg:', refAudio.error && refAudio.error.message,
            'currentSrc:', refAudio.currentSrc);
        });
      }

      // Reset to default 1× speed and full volume on each modal open
      if (speedSel) {
        speedSel.value = '1';
        refAudio.playbackRate = 1;
      }
      if (volSlider) {
        volSlider.value = '100';
        refAudio.volume = 1;
        refAudio.muted = false;
      }

      // setPlaying queries the button LIVE on every call — the button gets
      // clone-and-replaced below to wipe stale listeners, so refs captured
      // here would point at detached nodes (same reason renderLoopUI queries
      // by ID). Icons use toggleAttribute, not `.hidden =`: the hidden IDL
      // property doesn't exist on SVG elements, so assigning it does nothing.
      function setPlaying(isPlaying) {
        var btnLive = document.getElementById('SaifPracticeClipPlay');
        if (!btnLive) return;
        var iconPlay = btnLive.querySelector('.saif-maqam-practice-modal__clip-icon-play');
        var iconPause = btnLive.querySelector('.saif-maqam-practice-modal__clip-icon-pause');
        var label = btnLive.querySelector('.saif-maqam-practice-modal__clip-play-label');
        if (iconPlay) iconPlay.toggleAttribute('hidden', !!isPlaying);
        if (iconPause) iconPause.toggleAttribute('hidden', !isPlaying);
        if (label) label.textContent = isPlaying ? mqt('pause', 'Pause') : mqt('play', 'Play');
        btnLive.setAttribute('aria-label', isPlaying
          ? mqt('pause_reference', 'Pause reference clip')
          : mqt('play_reference', 'Play reference clip'));
      }
      function fmtTime(s) {
        if (!isFinite(s) || s < 0) s = 0;
        var m = Math.floor(s / 60);
        var sec = Math.floor(s % 60);
        return m + ':' + (sec < 10 ? '0' : '') + sec;
      }

      // Re-bind events on each modal open — replaceWith clears old listeners cleanly.
      var newBtn = playBtn.cloneNode(true);
      playBtn.parentNode.replaceChild(newBtn, playBtn);
      var newProgress = progress.cloneNode(true);
      progress.parentNode.replaceChild(newProgress, progress);
      // Re-acquire refs after clone
      newBtn.addEventListener('click', function () {
        if (refAudio.paused || refAudio.ended) {
          var p = refAudio.play();
          if (p && typeof p.then === 'function') {
            p.catch(function (err) {
              // AbortError fires when the audio src changed/reloaded mid-play —
              // benign here because we're about to reload anyway. Log other failures.
              if (err && err.name === 'AbortError') {
                console.log('[saif-maqam] clip play aborted (src reloading) — retrying once load is ready');
                var retry = function () {
                  refAudio.removeEventListener('canplay', retry);
                  refAudio.play().catch(function (e2) {
                    console.error('[saif-maqam] clip retry play also failed:', e2 && e2.name, e2 && e2.message);
                  });
                };
                refAudio.addEventListener('canplay', retry, { once: true });
              } else {
                console.error('[saif-maqam] clip play rejected:', err && err.name, err && err.message);
              }
            });
          }
        } else {
          refAudio.pause();
        }
      });
      // Pointer-drag scrubbing instead of a bare click handler — click-only
      // seeking gives touch users no way to drag to the phrase they want to
      // re-hear. Pointer capture keeps the drag alive even when the finger
      // wanders off the bar, and touch-action: none stops the page from
      // scroll-stealing the gesture (no CSS file change needed). Safe to
      // capture the fill here: it's a child of the freshly cloned bar, so
      // it lives exactly as long as these listeners do.
      newProgress.style.touchAction = 'none';
      var scrubFill = newProgress.querySelector('.saif-maqam-practice-modal__clip-progress-fill');
      var scrubbing = false;
      function seekToPointer(e) {
        if (!refAudio.duration) return;
        var rect = newProgress.getBoundingClientRect();
        if (!rect.width) return;
        var ratio = Math.max(0, Math.min(1, (e.clientX - rect.left) / rect.width));
        refAudio.currentTime = ratio * refAudio.duration;
        // Move the fill immediately so the bar tracks the finger instead of
        // waiting on the next (throttled) timeupdate — the timeupdate
        // listener still owns the aria-valuenow/valuetext bookkeeping.
        if (scrubFill) scrubFill.style.width = (ratio * 100) + '%';
      }
      newProgress.addEventListener('pointerdown', function (e) {
        if (!refAudio.duration) return;
        scrubbing = true;
        if (newProgress.setPointerCapture) {
          try { newProgress.setPointerCapture(e.pointerId); } catch (err) {}
        }
        seekToPointer(e);
      });
      newProgress.addEventListener('pointermove', function (e) {
        if (scrubbing) seekToPointer(e);
      });
      function stopScrub() { scrubbing = false; }
      newProgress.addEventListener('pointerup', stopScrub);
      newProgress.addEventListener('pointercancel', stopScrub);
      // Keyboard support for the role="slider" seek bar: arrows nudge ±5s,
      // Home/End jump to the start/end of the clip.
      newProgress.addEventListener('keydown', function (e) {
        if (!refAudio.duration) return;
        var target = null;
        if (e.key === 'ArrowLeft') target = Math.max(0, refAudio.currentTime - 5);
        else if (e.key === 'ArrowRight') target = Math.min(refAudio.duration, refAudio.currentTime + 5);
        else if (e.key === 'Home') target = 0;
        else if (e.key === 'End') target = refAudio.duration;
        if (target == null) return;
        e.preventDefault();
        refAudio.currentTime = target;
      });

      // Speed control — drives audio.playbackRate so the karaoke graph
      // (which reads refAudio.currentTime) stays in sync automatically.
      if (speedSel) {
        var newSpeed = speedSel.cloneNode(true);
        speedSel.parentNode.replaceChild(newSpeed, speedSel);
        newSpeed.value = '1';
        newSpeed.addEventListener('change', function () {
          refAudio.playbackRate = parseFloat(newSpeed.value) || 1;
        });
      }

      // Volume slider + mute toggle
      if (volSlider) {
        var newVol = volSlider.cloneNode(true);
        volSlider.parentNode.replaceChild(newVol, volSlider);
        newVol.addEventListener('input', function () {
          var v = parseInt(newVol.value, 10) / 100;
          refAudio.volume = isNaN(v) ? 1 : v;
          refAudio.muted = v === 0;
          syncMuteIcon();
        });
      }
      if (muteBtn) {
        var newMute = muteBtn.cloneNode(true);
        muteBtn.parentNode.replaceChild(newMute, muteBtn);
        newMute.addEventListener('click', function () {
          refAudio.muted = !refAudio.muted;
          syncMuteIcon();
        });
      }
      function syncMuteIcon() {
        var btn = document.getElementById('SaifPracticeClipMute');
        if (!btn) return;
        var on = btn.querySelector('.saif-maqam-practice-modal__clip-vol-on');
        var off = btn.querySelector('.saif-maqam-practice-modal__clip-vol-off');
        var muted = refAudio.muted || refAudio.volume === 0;
        // toggleAttribute — these are SVG elements, see setPlaying above.
        if (on) on.toggleAttribute('hidden', muted);
        if (off) off.toggleAttribute('hidden', !muted);
      }
      syncMuteIcon();

      // ── A-B loop ────────────────────────────────────────────────────────
      // State machine on a single button. We attach the loop bookkeeping
      // directly to the audio element so the timeupdate listener (which
      // fires from the same element across modal opens) can read it without
      // a closure over wireClipBar's per-call variables.
      refAudio._abLoop = { a: null, b: null, mode: 'idle' };
      // renderLoopUI must query elements LIVE on every call. The progress
      // bar and loop button get clone-and-replaced below to wipe stale
      // listeners — closing over the pre-clone references would target
      // detached DOM nodes (which is why "Loop A" appeared to do nothing
      // before this fix). querying-by-ID is cheap; do it.
      function renderLoopUI() {
        var s = refAudio._abLoop;
        var dur = refAudio.duration || 0;
        var loopBtnLive = document.getElementById('SaifPracticeClipLoopBtn');
        var loopLabelLive = document.getElementById('SaifPracticeClipLoopLabel');
        var loopMarkerA = document.getElementById('SaifPracticeClipLoopMarkerA');
        var loopMarkerB = document.getElementById('SaifPracticeClipLoopMarkerB');
        var loopRegion = document.getElementById('SaifPracticeClipLoopRegion');
        if (loopBtnLive) {
          loopBtnLive.classList.toggle('saif-maqam-practice-modal__clip-loop--armed', s.mode === 'a-set');
          loopBtnLive.classList.toggle('saif-maqam-practice-modal__clip-loop--active', s.mode === 'looping');
        }
        if (loopLabelLive) {
          loopLabelLive.textContent = s.mode === 'idle' ? mqt('loop_a', 'Loop A')
            : s.mode === 'a-set' ? mqt('loop_b', 'Loop B')
            : mqt('loop_on', 'Loop on');
        }
        function pos(el, t) {
          if (!el) return;
          if (t == null || !dur) { el.hidden = true; return; }
          el.style.left = Math.max(0, Math.min(100, (t / dur) * 100)) + '%';
          el.hidden = false;
        }
        pos(loopMarkerA, s.a);
        pos(loopMarkerB, s.b);
        if (loopRegion) {
          if (s.a != null && s.b != null && dur) {
            loopRegion.style.left = (s.a / dur * 100) + '%';
            loopRegion.style.width = ((s.b - s.a) / dur * 100) + '%';
            loopRegion.hidden = false;
          } else {
            loopRegion.hidden = true;
          }
        }
      }
      var loopBtn = document.getElementById('SaifPracticeClipLoopBtn');
      if (loopBtn) {
        var newLoopBtn = loopBtn.cloneNode(true);
        loopBtn.parentNode.replaceChild(newLoopBtn, loopBtn);
        // Stop the click from bubbling up to the document-level handler
        // that closes the options panel — the user wants to set A/B with
        // the panel still open so they can also tweak speed/volume.
        newLoopBtn.addEventListener('click', function (evt) {
          evt.stopPropagation();
          var s = refAudio._abLoop;
          var t = refAudio.currentTime || 0;
          console.log('[saif-maqam] loop click — mode:', s.mode, 'currentTime:', t);
          if (s.mode === 'idle') {
            s.a = t; s.mode = 'a-set';
            if (window.SaifTrack) window.SaifTrack('practice_loop_a_set', { time_s: Math.round(t * 10) / 10 });
          } else if (s.mode === 'a-set') {
            if (t <= s.a + 0.2) { s.a = t; renderLoopUI(); return; }
            s.b = t; s.mode = 'looping';
            if (window.SaifTrack) window.SaifTrack('practice_loop_started', {
              a_s: Math.round(s.a * 10) / 10,
              b_s: Math.round(s.b * 10) / 10,
              span_s: Math.round((s.b - s.a) * 10) / 10
            });
          } else {
            s.a = null; s.b = null; s.mode = 'idle';
            if (window.SaifTrack) window.SaifTrack('practice_loop_cleared', {});
          }
          renderLoopUI();
        });
      }
      // The loop enforcement runs from the existing timeupdate listener
      // below — checking _abLoop.mode so we don't bind a second listener
      // (refAudio is shared across modal opens; double-binding stacks).
      renderLoopUI();

      // Per-call state that the shared audio listeners need to read. We
      // stash these on the audio element so the listeners (which we only
      // bind once — see below) always pick up the LATEST values each time
      // the modal reopens with new clones of the buttons / progress bar.
      var newFill = newProgress.querySelector('.saif-maqam-practice-modal__clip-progress-fill');
      refAudio._clipBarRefs = {
        fill: newFill,
        progress: newProgress,
        time: timeEl,
        setPlaying: setPlaying,
        renderLoopUI: renderLoopUI
      };

      // Audio listeners — bind exactly ONCE per page life. The audio
      // element (#SaifPracticeRefAudio) is shared across modal opens, so
      // re-attaching here would stack listeners and leak. Subsequent
      // wireClipBar calls just refresh _clipBarRefs above and let the
      // already-bound listeners read the latest values.
      if (!refAudio._clipBarWired) {
        refAudio.addEventListener('timeupdate', function () {
          var refs = refAudio._clipBarRefs || {};
          if (refAudio.duration) {
            if (refs.fill) refs.fill.style.width = (refAudio.currentTime / refAudio.duration * 100) + '%';
            // Keep the role="slider" seek bar's ARIA state in sync for screen readers.
            if (refs.progress) {
              refs.progress.setAttribute('aria-valuenow', String(Math.round(refAudio.currentTime / refAudio.duration * 100)));
              refs.progress.setAttribute('aria-valuetext', fmtTime(refAudio.currentTime) + ' of ' + fmtTime(refAudio.duration));
            }
          }
          if (refs.time) refs.time.textContent = fmtTime(refAudio.currentTime) + ' / ' + fmtTime(refAudio.duration || 0);
          // A-B loop enforcement: when playhead crosses B, jump back to A.
          // 0.05s tolerance avoids missing the trigger if timeupdate fires late.
          var lp = refAudio._abLoop;
          if (lp && lp.mode === 'looping' && lp.a != null && lp.b != null &&
              refAudio.currentTime >= lp.b - 0.05) {
            refAudio.currentTime = lp.a;
          }
        });
        refAudio.addEventListener('play', function () {
          var refs = refAudio._clipBarRefs || {};
          if (refs.setPlaying) refs.setPlaying(true);
        });
        refAudio.addEventListener('pause', function () {
          var refs = refAudio._clipBarRefs || {};
          if (refs.setPlaying) refs.setPlaying(false);
        });
        refAudio.addEventListener('ended', function () {
          var refs = refAudio._clipBarRefs || {};
          if (refs.setPlaying) refs.setPlaying(false);
        });
        // Re-render loop UI whenever metadata loads (duration becomes known)
        refAudio.addEventListener('loadedmetadata', function () {
          var refs = refAudio._clipBarRefs || {};
          if (refs.renderLoopUI) refs.renderLoopUI();
        });
        refAudio._clipBarWired = true;
      }
      setPlaying(!refAudio.paused && !refAudio.ended);
    }

    function closePracticeModal() {
      if (!practiceModal) return;
      // Stop any in-progress recording / playback so it doesn't keep running
      // after the modal closes.
      var studio = window.SaifPracticeStudio;
      if (studio) {
        if (studio.state === 'recording' && typeof studio.stopRecording === 'function') {
          try { studio.stopRecording(); } catch (e) {}
        }
        if (studio.tunerActive && typeof studio.stopTuner === 'function') {
          try { studio.stopTuner(); } catch (e) {}
        }
        // Stop ALL studio audio (transport + history-list take + reference).
        // Older builds only paused _playbackAudio/refAudioEl and missed the
        // history audio, so a saved take kept playing after close.
        if (typeof studio.stopAllAudio === 'function') {
          try { studio.stopAllAudio(); } catch (e) {}
        } else {
          if (studio._playbackAudio) { try { studio._playbackAudio.pause(); } catch (e) {} }
          if (studio._historyAudio) { try { studio._historyAudio.pause(); } catch (e) {} }
          if (studio.refAudioEl) { try { studio.refAudioEl.pause(); } catch (e) {} }
        }
      }
      if (typeof practiceModal.close === 'function') practiceModal.close();
      else practiceModal.removeAttribute('open');
      syncScrollLock();
    }

    library.addEventListener('click', function (evt) {
      var btn = evt.target.closest('[data-open-examples]');
      if (!btn) return;
      var handle = (btn.getAttribute('data-maqam-handle') || '').toLowerCase();
      var name = btn.getAttribute('data-maqam-name') || handle;
      openModal(handle, name);
    });

    if (modalClose) modalClose.addEventListener('click', closeModal);
    modal.addEventListener('click', function (evt) {
      if (evt.target === modal) closeModal();
    });

    if (practiceClose) practiceClose.addEventListener('click', closePracticeModal);
    if (practiceModal) {
      practiceModal.addEventListener('click', function (evt) {
        if (evt.target === practiceModal) closePracticeModal();
      });
    }

    // Restore body scroll even when a dialog closes natively (e.g. browser
    // cancel) rather than through closeModal/closePracticeModal.
    modal.addEventListener('close', syncScrollLock);
    if (practiceModal) practiceModal.addEventListener('close', syncScrollLock);

    document.addEventListener('keydown', function (evt) {
      if (evt.key !== 'Escape') return;
      if (practiceModal && practiceModal.hasAttribute('open')) {
        // preventDefault suppresses the browser's native dialog-cancel,
        // which would otherwise ALSO close the examples dialog underneath —
        // Escape must only ever close the topmost layer.
        evt.preventDefault();
        var optionsPanel = document.getElementById('SaifPracticeClipOptions');
        if (optionsPanel && !optionsPanel.hidden) return; // wireClipBar's handler closes just the panel
        closePracticeModal();
      } else if (modal.hasAttribute('open')) {
        evt.preventDefault();
        closeModal();
      }
    });

    // Kick off the manifest fetch eagerly so button counts update on page load.
    // loadDataset() is synchronous (parses an inline JSON island), so we can
    // update the labels immediately after — bug previously left every button
    // showing "View 0 examples" because this update step was missing.
    loadDataset();
    updateButtonCounts();

    // Deep link: /pages/maqam-library?clip=<id> opens that clip's examples
    // modal and scrolls to it. <id> matches a manifest clip's filename stem
    // (e.g. "kurd_00") or its URL basename (e.g. "maqam-478-kurd-00").
    // Unknown ids are ignored — the library just renders normally.
    (function () {
      var clipId = '';
      try { clipId = (new URLSearchParams(window.location.search).get('clip') || '').trim().toLowerCase(); }
      catch (e) {}
      if (!clipId) return;
      var match = null;
      Object.keys(datasetByMaqam).some(function (key) {
        return datasetByMaqam[key].some(function (item) {
          var fileStem = String(item.filename || '').replace(/\.[^.]+$/, '').toLowerCase();
          var urlStem = (String(item.url || '').split('/').pop() || '').replace(/\.[^.]+$/, '').toLowerCase();
          if (clipId === fileStem || clipId === urlStem) { match = item; return true; }
          return false;
        });
      });
      if (!match) return;
      var handle = (match.maqam || '').toLowerCase();
      var cardBtn = library.querySelector('[data-open-examples][data-maqam-handle="' + handle + '"]');
      var displayName = cardBtn
        ? (cardBtn.getAttribute('data-maqam-name') || handle)
        : handle.charAt(0).toUpperCase() + handle.slice(1);
      openModal(handle, displayName);
      var clipCard = modalList.querySelector('.saif-maqam-clip[data-audio-url="' + match.url + '"]');
      if (clipCard) {
        clipCard.classList.add('saif-maqam-clip--linked');
        clipCard.scrollIntoView({ block: 'center' });
      }
    })();
  }
})();
